module.exports = __webpack_public_path__ + "img/12.de063109.png";